import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Delete all classes from body that start with 'u-'
        document.body.className.split(' ').forEach((className) => {
            if (className.match(/^u-/)) {
                document.body.classList.remove(className);
            }
        });
        let el = this.el;
        //Get data-color attribute
        let color = el.getAttribute('data-color');
        //Build array of class
        let classes = color.split(' ');

        //For each class in the array
        classes.forEach((className) => {
            //Add class to body
            document.body.classList.add(className);
        });
    }
}
